import React, {Component} from "react";
import Config from "../Config"
import axios from "axios";
import "./Main.css"
import Util from "../Util/Util";
import Grid from "./Grid/Grid";
import {
    Alert,
    alpha,
    AppBar,
    IconButton,
    InputBase,
    Snackbar,
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon,
    styled,
    Toolbar,
    Typography
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import {
    BarChart,
    ExitToApp,
    FirstPage,
    LastPage,
    NavigateBefore,
    NavigateNext, Person,
    PersonAddAlt1
} from "@mui/icons-material";
import NewPatientModal from "./Modal/Patient/NewPatientModal";
import ConsultModal from "./Modal/Consult/ConsultModal";
import GraphModal from "./Modal/Patient/Graph/GraphModal";
import ChartView from "./Chart/ChartView";

const Search = styled('div')(({theme}) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({theme}) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({theme}) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

export default class Main extends Component {

    delayTimer;

    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            loading: false,
            isDrawerOpened: false,
            openNewPatientModal: false,
            openNotification: false,
            openConsultModal: false,
            selectedPatient: {},
            alertMessage: '',
            openPatientInfoModal: false,
            openGraphModal: false,
            isChartViewOpen: false
        }
        this.logout = this.logout.bind(this);
        this.doSearch = this.doSearch.bind(this);
        this.loadData = this.loadData.bind(this);
        this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
        this.handleDrawerClose = this.handleDrawerClose.bind(this);

        this.closeNewPatientModal = this.closeNewPatientModal.bind(this);
        this.switchView = this.switchView.bind(this);
    }

    render() {
        let {
            data,
            loading,
            openNewPatientModal,
            openNotification,
            alertMessage,
            openConsultModal,
            selectedPatient,
            openPatientInfoModal,
            openGraphModal,
            isChartViewOpen
        } = this.state;
        data._embedded = data._embedded || {patientList: []};
        return (
            <div style={{background: '#f8f9fa'}} className="d-flex flex-column overflow-hidden min-vh-100 vh-100"
                 tabIndex={0}>
                <header>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography variant="h6" noWrap component="div"
                                        sx={{flexGrow: 1, display: {xs: 'none', sm: 'block'}}} className="unselectable">
                                Pediatria
                            </Typography>
                            <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ml: 2}}
                                        onClick={this.switchView}>
                                {!isChartViewOpen ? <BarChart/> : <Person/>}
                            </IconButton>
                            <Search>
                                <SearchIconWrapper>
                                    <SearchIcon/>
                                </SearchIconWrapper>
                                <StyledInputBase placeholder="Buscar..." inputProps={{'aria-label': 'search'}}
                                                 onKeyUp={this.doSearch}/>
                            </Search>
                            <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ml: 2}}
                                        onClick={this.logout}>
                                <ExitToApp/>
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                </header>
                <main role="main" style={{overflowY: 'auto', flex: 1, display: 'flex'}}>
                    {loading ? Util.renderLoading() : !isChartViewOpen ?
                        <Grid patients={data._embedded.patientList} onConsultOpen={this.onConsultOpen}
                              onPatientInfoOpen={this.onPatientInfoOpen} onGraphOpen={this.onGraphOpen}/> :
                        <ChartView/>}
                </main>
                <footer style={{height: '3rem', display: 'flex'}}>
                    {!isChartViewOpen ?
                        <AppBar position="fixed" color="primary" sx={{top: 'auto', bottom: 0}}>
                            <Toolbar sx={{margin: 'auto'}} variant="dense">
                                <IconButton color="inherit" disabled={!data._links.first}
                                            onClick={() => this.loadData(data._links.first.href)}>
                                    <FirstPage/>
                                </IconButton>
                                <IconButton color="inherit" disabled={!data._links.prev}
                                            onClick={() => this.loadData(data._links.prev.href)}>
                                    <NavigateBefore/>
                                </IconButton>
                                <IconButton color="inherit" disabled={!data._links.next}
                                            onClick={() => this.loadData(data._links.next.href)}>
                                    <NavigateNext/>
                                </IconButton>
                                <IconButton color="inherit" disabled={!data._links.last}
                                            onClick={() => this.loadData(data._links.last.href)}>
                                    <LastPage/>
                                </IconButton>
                                <Typography noWrap sx={{flexGrow: 1, display: {xs: 'none', sm: 'block'}}}>
                                    Página {data.page.number + 1} de {data.page.totalPages}
                                </Typography>
                            </Toolbar>

                            <SpeedDial ariaLabel="Agregar"
                                       FabProps={{
                                           sx: {
                                               bgcolor: 'secondary.main',
                                               '&:hover': {bgcolor: 'secondary.main',}
                                           }
                                       }}
                                       sx={{position: 'absolute', bottom: 16, right: 16}} icon={<SpeedDialIcon/>}>
                                <SpeedDialAction key="add-patient" icon={<PersonAddAlt1/>}
                                                 tooltipTitle="Agregar paciente"
                                                 onClick={() => this.showNewPatientModal()} title={"Agregar paciente"}/>
                            </SpeedDial>
                        </AppBar>
                        : null}
                </footer>

                <NewPatientModal open={openNewPatientModal} closeModal={this.closeNewPatientModal}/>
                <NewPatientModal open={openPatientInfoModal} patient={selectedPatient}
                                 closeModal={this.closePatientInfoModal}/>
                <ConsultModal open={openConsultModal} patient={selectedPatient} closeModal={this.closeConsultModal}/>
                <GraphModal open={openGraphModal} patient={selectedPatient} closeModal={this.closeGraphModal}/>
                <Snackbar open={openNotification} autoHideDuration={6000} onClose={this.handleNotificationClose}
                          anchorOrigin={{vertical: 'top', horizontal: 'right'}}>
                    <Alert onClose={this.handleNotificationClose} severity="success" sx={{width: '100%'}}>
                        {alertMessage}
                    </Alert>
                </Snackbar>
            </div>
        );
    }

    loadData(url) {
        this.setState({loading: true});
        Util.loadData(url, res => {
            if (res === undefined)
                this.setState({error: "Empty response from server, contact the admin."});
            else if (res.status === 401)
                this.logout();
            else if (res.status === 200)
                this.setState({data: res.data});
            this.setState({loading: false});
        });
    }

    doSearch(e) {
        let {isChartViewOpen} = this.state;
        if (isChartViewOpen)
            return;
        this.setState({loading: true});
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
            let url = Config.SEARCH_PATIENTS_API.replace("%text%", e.target.value);
            url = e.target.value === "" ? Config.LOAD_PATIENTS_API : url;
            this.loadData(url);
            clearTimeout(this.delayTimer);
        }, 650); // Will do the ajax stuff after 650 ms
    }

    logout() {
        axios.get(Config.LOGOUT_API, Config.AXIOS_CONFIG).then(() => window.location.href = "/");
    }

    handleDrawerOpen() {
        this.setState({isDrawerOpened: true});
    }

    handleDrawerClose() {
        this.setState({isDrawerOpened: false});
    }

    showNewPatientModal() {
        this.setState({isDrawerOpened: false, openNewPatientModal: true});
    }

    closeNewPatientModal(notificationMessage) {
        this.setState({openNewPatientModal: false});
        if (notificationMessage && notificationMessage !== '') {
            this.setState({openNotification: true, alertMessage: notificationMessage});
            this.loadData();
        }
    }

    closePatientInfoModal = (notificationMessage) => {
        this.setState({openPatientInfoModal: false});
        if (notificationMessage && notificationMessage !== '') {
            this.setState({openNotification: true, alertMessage: notificationMessage});
            this.loadData();
        }
    }

    handleNotificationClose = (event, reason) => {
        if (reason === 'clickaway')
            return;
        this.setState({openNotification: false});
    };

    onConsultOpen = (patient) => {
        this.setState({openConsultModal: true, selectedPatient: patient});
    }

    onPatientInfoOpen = (patient) => {
        this.setState({openPatientInfoModal: true, selectedPatient: patient});
    }

    onGraphOpen = (patient) => {
        this.setState({openGraphModal: true, selectedPatient: patient});
    }

    closeConsultModal = (notificationText) => {
        this.setState({
            openConsultModal: false,
            openNotification: !(notificationText === undefined || notificationText === ""),
            alertMessage: notificationText
        });
    }

    closeGraphModal = () => {
        this.setState({openGraphModal: false});
    }

    switchView() {
        let {isChartViewOpen} = this.state;
        this.setState({isChartViewOpen: !isChartViewOpen});
    }
}